'use client'
import { formatWorkingHours } from '@/helpers/formatWorkingHours'
import { Map, Placemark, YMaps } from '@pbe/react-yandex-maps'
import { useLocale, useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'
import { Button } from 'rsuite'
import styles from './map.module.scss'
import { YandexMapProps } from './types'
const API_KEY = 'a9574d29-a9a4-4ce6-b3bf-99919499ad18'

interface MapProps {
  stores: YandexMapProps[]
  handleOrderClick?: (id?: string) => void
}

const YandexMap: React.FC<MapProps> = ({ stores, handleOrderClick }) => {
  const [newCoords, setNewCoords] = useState(stores[0]?.coords || [0, 0])
  const locale = useLocale()
  const [activeLocation, setActiveLocation] = useState(stores[0])
  const t = useTranslations('General')
  const [value, setValue] = useState('')
  const [options, setOptions] = useState([])

  useEffect(() => {
    ;(async () => {
      try {
        if (value) {
          const res = await fetch(
            `https://geocode-maps.yandex.ru/1.x/?apikey=${API_KEY}&format=json&geocode=${value}`
          )
          const data = await res.json()
          const collection =
            data.response.GeoObjectCollection.featureMember.map(
              (item: { GeoObject: any }) => item.GeoObject
            )
          setOptions(() => collection)
        }
      } catch (e) {
        console.log(e)
      }
    })()
  }, [value])

  return (
    <div className={styles.mapWrapper}>
      <YMaps
        query={{
          lang: 'en_RU',
          load: 'package.full',
          apikey: API_KEY,
        }}
      >
        <div className={styles.map}>
          <Map
            state={{
              center: newCoords,
              zoom: 12,
              controls: ['fullscreenControl'],
            }}
            width={'100% !important'}
            style={{
              width: '100% !important',
              height: '540px',
            }}
            height="548px"
            modules={['control.FullscreenControl']}
            defaultState={{ center: [41.2995, 69.2401], zoom: 12 }}
          >
            {' '}
            {stores?.map((store) => (
              <Placemark
                key={store?.id}
                geometry={store?.coords}
                options={{
                  iconLayout: 'default#image',
                  iconImageHref:
                    activeLocation?.id == store?.id
                      ? '/placemark-icon-active.svg'
                      : '/placemark-icon.svg',
                  iconImageSize: [28, 32],
                  iconImageOffset: [-15, -42],
                }}
                properties={{
                  hintContent: store?.address,
                  ballengContent: false,
                }}
                onClick={() => {
                  setActiveLocation(store)
                  setNewCoords(store?.coords)
                }}
              />
            ))}
          </Map>
          <div className={styles?.addressCard}>
            <div className={styles?.header}>
              <h3>{activeLocation?.address}</h3>
            </div>
            <div className={styles.texts}>
              <p>{activeLocation.mall}</p>
              <p>{activeLocation.phone}</p>
              <div>
                {' '}
                {formatWorkingHours(activeLocation?.workSchedule,locale).map(
                  (schedule, i) => (
                    <p key={i} className={styles.scheduleText}>
                      {schedule}
                    </p>
                  )
                )}
              </div>
            </div>
            <Button
              disabled={activeLocation.available === 0}
              onClick={() => handleOrderClick?.(activeLocation.id)}
              className={styles.btn}
            >
              {t('select')}
            </Button>
          </div>
        </div>
      </YMaps>
    </div>
  )
}

export default YandexMap
